import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { StyledAddToHomePageButton } from './style';
import { Gradient } from '../Helper/types';

type AddToHomePageButtonProps = {
  onClick: () => any;
  borderColor?: string;
  backgroundColor?: Gradient;
  isMockPreview?: boolean;
};

const Button = ({
  onClick,
  borderColor = '#ffffff',
  backgroundColor = { colorOne: '#522AD8', colorTwo: '#7946FA' },
  isMockPreview = false,
}: AddToHomePageButtonProps) => {
  return (
    <StyledAddToHomePageButton
      onClick={onClick}
      borderColor={borderColor}
      bgColor={backgroundColor}
      className={isMockPreview ? 'dashboard-preview' : ''}
    >
      <AddCircleOutlineIcon className="icon" style={{ color: borderColor }} />
      <div className="description">
        <div>Add to</div>
        <div>Home Screen</div>
      </div>
    </StyledAddToHomePageButton>
  );
};

export default Button;
